<!--
  REV-21359 — account overview (Pure View), 
-->
<div class="acc" data-testid="accounts">
    <div class="acc-filters" data-testid="accounts-filters" *ngIf="filterGroups.length || hasPositions">
        <div
            class="acc-filter-group"
            data-testid="accounts-filter-group"
            *ngFor="let group of filterGroups; trackBy: trackById"
            [attr.data-align]="group.align"
        >
            <span class="acc-filter-group__label" *ngIf="group.label">{{ group.label }}</span>
            <ham-filter-pill
                data-testid="accounts-filter-chip"
                [attr.data-chip-id]="chip.id"
                *ngFor="let chip of group.chips; trackBy: trackById"
                [label]="chip.label"
                [active]="chip.active"
                [disabled]="chip.disabled === true"
                [hamTooltip]="chip.reason ?? ''"
                tooltipClass="abcp"
                (pillClick)="onFilterClick(chip.id)"
            ></ham-filter-pill>
        </div>
        <!-- Opens or closes every position at once, as in the Mehrjahresvergleich. -->
        <ham-button
            class="acc-details-toggle"
            data-testid="accounts-details-toggle"
            *ngIf="hasPositions"
            variant="white"
            outline="true"
            size="toolbar"
            [attr.data-expanded]="allExpanded"
            (buttonClick)="onDetailsClick()"
        >
            {{
                (allExpanded
                    ? 'aumico_reports_equality_check_print_preview_hide_details'
                    : 'aumico_reports_equality_check_print_preview_show_details'
                ) | i18next
            }}
        </ham-button>
    </div>

    <!-- TABELLE — der Scroll-Container trägt Rahmen und Radius, damit beides beim Scrollen steht. -->
    <div class="acc-scroll">
        <table class="acc-table" data-testid="accounts-table" [style.min-width.px]="tableMinWidth">
            <!-- Fixed column widths, so expanding a position never shifts the figures. -->
            <colgroup>
                <col [style.width.px]="numberColumnWidth" />
                <col />
                <col *ngFor="let column of columns" [style.width.px]="columnWidth(column)" />
                <col *ngIf="showStatus" [style.width.px]="statusColumnWidth" />
            </colgroup>
            <!-- A statement in sections repeats the headings in each section row instead. -->
            <thead *ngIf="!hasSections">
                <tr class="acc-head">
                    <th class="acc-head__cell" scope="col">{{ 'abcp_accounts_col_number' | i18next }}</th>
                    <th class="acc-head__cell acc-head__cell--label" scope="col">
                        {{ 'abcp_accounts_col_label' | i18next }}
                    </th>
                    <th
                        class="acc-head__cell acc-head__cell--value"
                        data-testid="accounts-column"
                        scope="col"
                        *ngFor="let column of columns"
                        [class.acc-cell--current]="column.current"
                    >
                        {{ column.label }}
                    </th>
                    <th
                        class="acc-head__cell acc-head__cell--status"
                        data-testid="accounts-status-column"
                        scope="col"
                        *ngIf="showStatus"
                    >
                        {{ 'abcp_accounts_col_status' | i18next }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <!-- Zustände, Präzedenz loading > error > empty > filled (Muster: navigation-bar). -->
                <tr *ngIf="showSkeleton">
                    <td class="acc-state" [attr.colspan]="columnCount">
                        <div class="acc-loading" data-testid="accounts-loading">
                            <div class="acc-skeleton" *ngFor="let row of skeletonRows" aria-hidden="true"></div>
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!loading && error">
                    <td class="acc-state" [attr.colspan]="columnCount">
                        <div class="acc-error" data-testid="accounts-error">
                            {{ 'abcp_accounts_error' | i18next }}
                        </div>
                    </td>
                </tr>

                <tr *ngIf="!loading && !error && isEmpty">
                    <td class="acc-state" [attr.colspan]="columnCount">
                        <div class="acc-empty" data-testid="accounts-empty">{{ 'abcp_accounts_empty' | i18next }}</div>
                    </td>
                </tr>

                <ng-container *ngIf="!error && !isEmpty">
                    <ng-container *ngFor="let row of rows; let i = index; trackBy: trackByRowId">
                        <!-- SEKTION — «Aktiven in CHF», mit den Spaltenköpfen. -->
                        <tr
                            class="acc-row acc-row--section"
                            data-testid="accounts-row"
                            data-kind="section"
                            *ngIf="row.kind === 'section'"
                        >
                            <td class="acc-row__title" colspan="2">
                                <span
                                    class="acc-label"
                                    [hamTooltip]="row.label"
                                    tooltipClass="abcp"
                                    [tooltipOnlyWhenTruncated]="true"
                                    >{{ row.label }}</span
                                >
                            </td>
                            <td
                                class="acc-cell acc-cell--value"
                                data-testid="accounts-section-column"
                                *ngFor="let column of columns"
                                [class.acc-cell--current]="column.current"
                            >
                                {{ column.label }}
                            </td>
                            <td class="acc-cell acc-cell--status" *ngIf="showStatus">
                                {{ 'abcp_accounts_col_status' | i18next }}
                            </td>
                        </tr>

                        <!-- ÜBERSCHRIFT — Kopf einer Gruppe; ihre Zahlen stehen in der Totalzeile. -->
                        <tr
                            class="acc-row acc-row--heading"
                            data-testid="accounts-row"
                            data-kind="heading"
                            *ngIf="row.kind === 'heading'"
                            [class.acc-row--before-total]="isBeforeTotal(i)"
                        >
                            <td class="acc-row__title" [attr.colspan]="columnCount">
                                <span
                                    class="acc-label"
                                    [hamTooltip]="row.label"
                                    tooltipClass="abcp"
                                    [tooltipOnlyWhenTruncated]="true"
                                    >{{ row.label }}</span
                                >
                            </td>
                        </tr>

                        <!-- POSITION — aufklappbar, mit der Summe ihrer Konten. -->
                        <tr
                            class="acc-row acc-row--group"
                            data-testid="accounts-row"
                            data-kind="group"
                            *ngIf="row.kind === 'group'"
                            [class.acc-row--before-total]="isBeforeTotal(i)"
                            [attr.data-expanded]="row.isExpanded"
                        >
                            <td class="acc-row__title" colspan="2">
                                <button
                                    type="button"
                                    class="acc-group-toggle"
                                    data-testid="accounts-group-toggle"
                                    [attr.aria-expanded]="row.isExpanded"
                                    (click)="onGroupClick(row.id)"
                                >
                                    <span
                                        class="ham-icon acc-chevron"
                                        [class.is-collapsed]="!row.isExpanded"
                                        aria-hidden="true"
                                    >
                                        <i class="chevron-down-icon"></i>
                                    </span>
                                    <span
                                        class="acc-label"
                                        [hamTooltip]="row.label"
                                        tooltipClass="abcp"
                                        [tooltipOnlyWhenTruncated]="true"
                                        >{{ row.label }}</span
                                    >
                                    <span
                                        class="ham-icon acc-check"
                                        data-testid="accounts-group-check"
                                        *ngIf="row.allReconciled"
                                        [hamTooltip]="'abcp_accounts_group_reconciled_tooltip' | i18next"
                                        tooltipClass="abcp"
                                    >
                                        <i class="check-circle"></i>
                                    </span>
                                </button>
                            </td>

                            <ng-container
                                *ngTemplateOutlet="valueCells; context: { $implicit: row.values }"
                            ></ng-container>
                            <td class="acc-cell acc-cell--status" *ngIf="showStatus">
                                <abcp-status-pie
                                    data-testid="accounts-group-status"
                                    *ngIf="row.statusCounts as counts"
                                    [counts]="counts"
                                ></abcp-status-pie>
                            </td>
                        </tr>

                        <!-- KONTO — Klick auf die Zeile führt auf die neue Seite (Container navigiert). -->
                        <tr
                            class="acc-row acc-row--account"
                            data-testid="accounts-row"
                            data-kind="account"
                            *ngIf="row.kind === 'account'"
                            [class.acc-row--before-total]="isBeforeTotal(i)"
                            [attr.data-status]="showStatus ? row.status : null"
                            role="button"
                            tabindex="0"
                            (click)="onAccountClick(row.id)"
                            (keydown.enter)="onAccountClick(row.id)"
                            (keydown.space)="onAccountClick(row.id); $event.preventDefault()"
                        >
                            <td class="acc-cell acc-cell--number">{{ row.number }}</td>
                            <td class="acc-cell acc-cell--label">
                                <span
                                    class="acc-label"
                                    [hamTooltip]="row.label"
                                    tooltipClass="abcp"
                                    [tooltipOnlyWhenTruncated]="true"
                                    >{{ row.label }}</span
                                >
                                <span
                                    class="ham-icon acc-flag"
                                    data-testid="accounts-flag"
                                    *ngIf="showReview && row.marked"
                                >
                                    <i class="flag-icon"></i>
                                </span>
                            </td>

                            <ng-container
                                *ngTemplateOutlet="valueCells; context: { $implicit: row.values }"
                            ></ng-container>

                            <td class="acc-cell acc-cell--status" *ngIf="showStatus">
                                <ham-badge-button
                                    class="acc-status"
                                    *ngIf="row.status"
                                    [variant]="statusVariant(row.status)"
                                >
                                    {{ statusLabelKey(row.status) | i18next }}
                                </ham-badge-button>
                            </td>
                        </tr>

                        <!-- TOTAL einer Gruppe; `root` schliesst einen ganzen Block (Total Aktiven). -->
                        <tr
                            class="acc-row acc-row--total"
                            data-testid="accounts-row"
                            data-kind="total"
                            *ngIf="row.kind === 'total'"
                            [class.acc-row--root]="row.level === 'root'"
                            [attr.data-level]="row.level ?? 'group'"
                        >
                            <td class="acc-row__title" colspan="2">
                                <span
                                    class="acc-label"
                                    [hamTooltip]="row.label"
                                    tooltipClass="abcp"
                                    [tooltipOnlyWhenTruncated]="true"
                                    >{{ row.label }}</span
                                >
                            </td>

                            <ng-container
                                *ngTemplateOutlet="valueCells; context: { $implicit: row.values }"
                            ></ng-container>
                            <td class="acc-cell acc-cell--status" *ngIf="showStatus"></td>
                        </tr>

                        <!-- ZWISCHENSUMME — Staffelform (Bruttogewinn, EBIT, Jahresgewinn). -->
                        <tr
                            class="acc-row acc-row--subtotal"
                            data-testid="accounts-row"
                            data-kind="subtotal"
                            *ngIf="row.kind === 'subtotal'"
                        >
                            <td class="acc-row__title" colspan="2">
                                <span
                                    class="acc-label"
                                    [hamTooltip]="row.label"
                                    tooltipClass="abcp"
                                    [tooltipOnlyWhenTruncated]="true"
                                    >{{ row.label }}</span
                                >
                            </td>

                            <ng-container
                                *ngTemplateOutlet="valueCells; context: { $implicit: row.values }"
                            ></ng-container>
                            <td class="acc-cell acc-cell--status" *ngIf="showStatus"></td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>

<!--
  ZAHLENZELLEN 
-->
<ng-template #valueCells let-values>
    <td
        class="acc-cell acc-cell--value"
        data-testid="accounts-cell"
        *ngFor="let column of columns; let i = index"
        [ngClass]="'acc-cell--' + column.kind"
        [class.acc-cell--current]="column.current"
        [attr.data-material]="cellAt(values, i)?.material"
    >
        <ng-container *ngIf="cellAt(values, i) as cell">
            <span class="acc-value" *ngIf="cell.value !== null; else emptyValue" [class.is-material]="cell.material">
                {{ signPrefix(cell.value, column) }}{{ cell.value | finNumber : numberFormat(column)
                }}{{ unitSuffix(column) }}
            </span>
            <ng-template #emptyValue><span class="acc-value acc-value--empty">—</span></ng-template>
        </ng-container>
    </td>
</ng-template>
